import { call, put, select, takeLatest } from 'redux-saga/effects'
import { OptionsService } from '../services/options.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setHospitalNameOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getHospitalNameOptions])
    const { entity } = response
    yield put(actions.setHospitalNameOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setHospitalNameOptions() error: ${e}`))
  }
}
export function* setHospitalNameOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setHospitalNameOptions)
}
